import { useTranslations } from 'next-intl';
import { MetaDefault } from '@terra/ui-design-system';
import { Box, VStack } from '@terra/ui-styled-system';
import type { WorkspaceSummary } from '../../../electron-shared/workspace/workspace-descriptor';
import { RecentWorkspaceCard } from './RecentWorkspaceCard';

const JUMP_BACK_IN_COUNT = 4;

type JumpBackInSectionProps = {
  workspaces: WorkspaceSummary[];
  showTenantName: boolean;
  onOpen: (workspace: WorkspaceSummary) => void;
  onRemove: (workspaceId: string) => void;
};

export function JumpBackInSection({
  workspaces,
  showTenantName,
  onOpen,
  onRemove,
}: JumpBackInSectionProps) {
  const t = useTranslations('proxy.workspaces');

  if (workspaces.length === 0) {
    return null;
  }

  return (
    <VStack gap="2" w="full" alignItems="stretch">
      <MetaDefault color="fg.neutral.muted">{t('jumpBackIn')}</MetaDefault>
      <Box
        display="grid"
        gridTemplateColumns="repeat(2, minmax(0, 1fr))"
        gap="3"
      >
        {workspaces.slice(0, JUMP_BACK_IN_COUNT).map((workspace) => (
          <RecentWorkspaceCard
            key={workspace.id}
            workspace={workspace}
            showTenantName={showTenantName}
            onOpen={onOpen}
            onRemove={onRemove}
          />
        ))}
      </Box>
    </VStack>
  );
}
